// CONCEPT: dialogs are interaction code, not a prerequisite for rendering a catalog page.
// USE: showAlert(config) preserves SweetAlert's promise result; a failed chunk never confirms.
let loading;

// A dialog rendered into <body> while a Bootstrap modal is open sits outside that modal's focus
// trap, so Bootstrap pulls focus back into the modal on every focusin and the dialog's buttons
// can never be reached, and Escape closes the modal beneath instead (#1748). Rendering it INSIDE
// the topmost open modal puts it within the trap; SweetAlert stops Escape and Tab at its own
// popup (stopKeydownPropagation defaults on), so the modal does not see them. Toasts stay in body.
function dialogConfig(config) {
    if (!config || typeof config !== 'object' || config.target || config.toast) {
        return config;
    }
    const open = document.querySelectorAll('.modal.show');
    if (!open.length) {
        return config;
    }
    return { ...config, target: open[open.length - 1] };
}

export function showAlert(config) {
    if (!loading) {
        loading = import('sweetalert2').then(
            ({ default: Swal }) => Swal,
            (error) => {
                loading = undefined;
                throw error;
            }
        );
    }
    return loading.then(
        (Swal) => Swal.fire(dialogConfig(config)),
        (error) => {
            console.error('[dialog] Could not load dialog', error);
            window.alert('Could not open this message. Please reload the page and try again.');
            return { isConfirmed: false, isDenied: false, isDismissed: true };
        }
    );
}
